/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStorytellingRelatedContent_storyTellingTab = {
    readonly supplementaryEditorial: {
        readonly totalResults: number | null;
        readonly articles: ReadonlyArray<{
            readonly title: string;
            readonly imageUrl: {
                readonly thumb: string;
                readonly medium: string;
                readonly full: string;
            };
            readonly link: string;
            readonly source: string;
        }> | null;
    } | null;
    readonly " $refType": "PdpSharedStorytellingRelatedContent_storyTellingTab";
};
export type PdpSharedStorytellingRelatedContent_storyTellingTab$data = PdpSharedStorytellingRelatedContent_storyTellingTab;
export type PdpSharedStorytellingRelatedContent_storyTellingTab$key = {
    readonly " $data"?: PdpSharedStorytellingRelatedContent_storyTellingTab$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedStorytellingRelatedContent_storyTellingTab">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedStorytellingRelatedContent_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WordpressArticlesType",
      "kind": "LinkedField",
      "name": "supplementaryEditorial",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WordpressArticleType",
          "kind": "LinkedField",
          "name": "articles",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "WordpressArticleImageType",
              "kind": "LinkedField",
              "name": "imageUrl",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "thumb",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "medium",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "full",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "source",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};
(node as any).hash = '3b9418443e5887e15ccc48537c18a257';
export default node;
